<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.59998 4.00001C9.59998 3.55841 9.95837 3.20001 10.4 3.20001H13.6C14.0416 3.20001 14.4 3.55841 14.4 4.00001V4.80001H20.8C21.684 4.80001 22.4 5.51601 22.4 6.40001V19.2C22.4 20.084 21.684 20.8 20.8 20.8L19.75 20.8H19.5V4.80002H18.5V20.8H18.25H5.75H5.5V4.80002H4.5V20.8H4.25L3.19998 20.8C2.31598 20.8 1.59998 20.084 1.59998 19.2V6.40001C1.59998 5.51601 2.31598 4.80001 3.19998 4.80001H9.59998V4.00001Z" fill="#000000"/>
</g>
<defs>
<clipPath id="clip0">
<rect width="20" height="20" fill="white" transform="translate(2 22) rotate(-90)"/>
</clipPath>
</defs>
</svg>
